import React, { FC, memo } from 'react'
import { Svg, Path, SvgProps } from 'react-native-svg'

const ShieldFilledIcon: FC<SvgProps> = ({
  width = 12,
  height = 15,
  color = '#999999',
  ...props
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 12 15" fill="none" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.80949 0.0137062C5.93596 -0.00456873 6.0644 -0.00456873 6.19087 0.0137062C6.33662 0.0347678 6.47224 0.0860038 6.57993 0.126687L6.60879 0.137563L10.2704 1.51058C10.6823 1.66434 11.044 1.79938 11.3225 2.04486C11.5662 2.25961 11.7539 2.53047 11.8694 2.83404C12.0015 3.18104 12.0009 3.56712 12.0003 4.00675L12.0002 7.288C12.0002 9.17242 10.9753 10.7435 9.86747 11.8976C8.7522 13.0595 7.47618 13.8801 6.80144 14.2738L6.77412 14.2898C6.65099 14.3621 6.49117 14.4559 6.27975 14.5013C6.10678 14.5383 5.89357 14.5383 5.7206 14.5013C5.50919 14.4559 5.34937 14.3621 5.22624 14.2898L5.19891 14.2738C4.52417 13.8801 3.24815 13.0595 2.13288 11.8976C1.02504 10.7435 0.000176554 9.17242 0.000176554 7.288L8.7147e-05 4.00675C-0.00054951 3.56712 -0.00110869 3.18104 0.130937 2.83404C0.246451 2.53047 0.434159 2.25961 0.677835 2.04486C0.956383 1.79938 1.31808 1.66434 1.72994 1.51058L5.39156 0.137563L5.42042 0.126688C5.52811 0.0860044 5.66373 0.0347679 5.80949 0.0137062ZM8.8049 5.75949C9.06525 5.49914 9.06525 5.07703 8.8049 4.81668C8.54455 4.55633 8.12244 4.55633 7.86209 4.81668L5.3335 7.34528L4.47157 6.48335C4.21122 6.223 3.78911 6.223 3.52876 6.48335C3.26841 6.7437 3.26841 7.16581 3.52876 7.42616L4.86209 8.75949C5.12244 9.01984 5.54455 9.01984 5.8049 8.75949L8.8049 5.75949Z"
        fill={color}
      />
    </Svg>
  )
}

export default memo(ShieldFilledIcon)
